/* global algoliasearch instantsearch */

const searchClient = algoliasearch('K1YOHFJPP5', 'c1898326dd54ad54cee3082d1590a5a5');

const search = instantsearch({
  indexName: 'test_THEMES',
  searchClient,
});

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      item: `
<article>
  <img width="100%" src="{{theme_image}}"/>
  <br/><br/>
  <h1>{{#helpers.highlight}}{ "attribute": "theme_id" }{{/helpers.highlight}}. {{#helpers.highlight}}{ "attribute": "theme_name" }{{/helpers.highlight}}</h1>
  <!--<p>{{#helpers.highlight}}{ "attribute": "theme_first_post_formatted" }{{/helpers.highlight}}</p>
  <p>{{#helpers.highlight}}{ "attribute": "theme_last_update_formatted" }{{/helpers.highlight}}</p>-->
  <br/>
  <a href="{{theme_repo_link}}">Github Repo</a> | 
  <a href="{{theme_preview_link}}">Preview</a>
</article>
`,
  empty: 'No results for <q>{{ query }}</q>',
    },
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
]);

search.start();
